module.exports = __webpack_public_path__ + "media/sod-medium.45612208.mp4";